import { isAnalyticsHomepageRegex } from 'hybridspace-telemetry';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

// Check shouldStartPlacesAnalyticsAlt.Test.ts to understand the scenarios covered
export function shouldStartPlacesAnalyticsAlt(pathname: string): boolean {
    return isGlobalFeatureEnabled('msplaces-home-page') && isPlacesAnalyticsHomePage(pathname);
}

export function isPlacesAnalyticsHomePage(pathname: string): boolean {
    const homepageRegex = new RegExp(isAnalyticsHomepageRegex, 'i' /* Flag for case insensitive */);
    return (pathname.match(homepageRegex) || []).length > 0;
}
